import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=966a87a4&"
import script from "./SSO.vue?vue&type=script&lang=js&"
export * from "./SSO.vue?vue&type=script&lang=js&"
import style0 from "./SSO.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports